/**
 * Responsive AVIF/WebP sources for landing parallax layers.
 * Widths: 960 (phone/tablet), 1600 (desktop), 2400 (wide / 2×).
 * <img> fallback uses 1600 WebP (universal support) — no multi-MB PNG in the bundle.
 */

import dark1_960_avif from '../../assets/bg/responsive/bg-dark-1-960.avif';
import dark1_1600_avif from '../../assets/bg/responsive/bg-dark-1-1600.avif';
import dark1_2400_avif from '../../assets/bg/responsive/bg-dark-1-2400.avif';
import dark1_960_webp from '../../assets/bg/responsive/bg-dark-1-960.webp';
import dark1_1600_webp from '../../assets/bg/responsive/bg-dark-1-1600.webp';
import dark1_2400_webp from '../../assets/bg/responsive/bg-dark-1-2400.webp';

import dark2_960_avif from '../../assets/bg/responsive/bg-dark-2-transparent-960.avif';
import dark2_1600_avif from '../../assets/bg/responsive/bg-dark-2-transparent-1600.avif';
import dark2_2400_avif from '../../assets/bg/responsive/bg-dark-2-transparent-2400.avif';
import dark2_960_webp from '../../assets/bg/responsive/bg-dark-2-transparent-960.webp';
import dark2_1600_webp from '../../assets/bg/responsive/bg-dark-2-transparent-1600.webp';
import dark2_2400_webp from '../../assets/bg/responsive/bg-dark-2-transparent-2400.webp';

import dark3_960_avif from '../../assets/bg/responsive/bg-dark-3-transparent-960.avif';
import dark3_1600_avif from '../../assets/bg/responsive/bg-dark-3-transparent-1600.avif';
import dark3_2400_avif from '../../assets/bg/responsive/bg-dark-3-transparent-2400.avif';
import dark3_960_webp from '../../assets/bg/responsive/bg-dark-3-transparent-960.webp';
import dark3_1600_webp from '../../assets/bg/responsive/bg-dark-3-transparent-1600.webp';
import dark3_2400_webp from '../../assets/bg/responsive/bg-dark-3-transparent-2400.webp';

import dark4_960_avif from '../../assets/bg/responsive/bg-dark-4-transparent-960.avif';
import dark4_1600_avif from '../../assets/bg/responsive/bg-dark-4-transparent-1600.avif';
import dark4_2400_avif from '../../assets/bg/responsive/bg-dark-4-transparent-2400.avif';
import dark4_960_webp from '../../assets/bg/responsive/bg-dark-4-transparent-960.webp';
import dark4_1600_webp from '../../assets/bg/responsive/bg-dark-4-transparent-1600.webp';
import dark4_2400_webp from '../../assets/bg/responsive/bg-dark-4-transparent-2400.webp';

import dark5_960_avif from '../../assets/bg/responsive/bg-dark-5-transparent-960.avif';
import dark5_1600_avif from '../../assets/bg/responsive/bg-dark-5-transparent-1600.avif';
import dark5_2400_avif from '../../assets/bg/responsive/bg-dark-5-transparent-2400.avif';
import dark5_960_webp from '../../assets/bg/responsive/bg-dark-5-transparent-960.webp';
import dark5_1600_webp from '../../assets/bg/responsive/bg-dark-5-transparent-1600.webp';
import dark5_2400_webp from '../../assets/bg/responsive/bg-dark-5-transparent-2400.webp';

import light1_960_avif from '../../assets/bg/responsive/bg-light-1-960.avif';
import light1_1600_avif from '../../assets/bg/responsive/bg-light-1-1600.avif';
import light1_2400_avif from '../../assets/bg/responsive/bg-light-1-2400.avif';
import light1_960_webp from '../../assets/bg/responsive/bg-light-1-960.webp';
import light1_1600_webp from '../../assets/bg/responsive/bg-light-1-1600.webp';
import light1_2400_webp from '../../assets/bg/responsive/bg-light-1-2400.webp';

import light2_960_avif from '../../assets/bg/responsive/bg-light-2-transparent-960.avif';
import light2_1600_avif from '../../assets/bg/responsive/bg-light-2-transparent-1600.avif';
import light2_2400_avif from '../../assets/bg/responsive/bg-light-2-transparent-2400.avif';
import light2_960_webp from '../../assets/bg/responsive/bg-light-2-transparent-960.webp';
import light2_1600_webp from '../../assets/bg/responsive/bg-light-2-transparent-1600.webp';
import light2_2400_webp from '../../assets/bg/responsive/bg-light-2-transparent-2400.webp';

import light3_960_avif from '../../assets/bg/responsive/bg-light-3-transparent-960.avif';
import light3_1600_avif from '../../assets/bg/responsive/bg-light-3-transparent-1600.avif';
import light3_2400_avif from '../../assets/bg/responsive/bg-light-3-transparent-2400.avif';
import light3_960_webp from '../../assets/bg/responsive/bg-light-3-transparent-960.webp';
import light3_1600_webp from '../../assets/bg/responsive/bg-light-3-transparent-1600.webp';
import light3_2400_webp from '../../assets/bg/responsive/bg-light-3-transparent-2400.webp';

import light4_960_avif from '../../assets/bg/responsive/bg-light-4-transparent-960.avif';
import light4_1600_avif from '../../assets/bg/responsive/bg-light-4-transparent-1600.avif';
import light4_2400_avif from '../../assets/bg/responsive/bg-light-4-transparent-2400.avif';
import light4_960_webp from '../../assets/bg/responsive/bg-light-4-transparent-960.webp';
import light4_1600_webp from '../../assets/bg/responsive/bg-light-4-transparent-1600.webp';
import light4_2400_webp from '../../assets/bg/responsive/bg-light-4-transparent-2400.webp';

import light6_960_avif from '../../assets/bg/responsive/bg-light-6-transparent-960.avif';
import light6_1600_avif from '../../assets/bg/responsive/bg-light-6-transparent-1600.avif';
import light6_2400_avif from '../../assets/bg/responsive/bg-light-6-transparent-2400.avif';
import light6_960_webp from '../../assets/bg/responsive/bg-light-6-transparent-960.webp';
import light6_1600_webp from '../../assets/bg/responsive/bg-light-6-transparent-1600.webp';
import light6_2400_webp from '../../assets/bg/responsive/bg-light-6-transparent-2400.webp';

import light7_960_avif from '../../assets/bg/responsive/bg-light-7-transparent-960.avif';
import light7_1600_avif from '../../assets/bg/responsive/bg-light-7-transparent-1600.avif';
import light7_2400_avif from '../../assets/bg/responsive/bg-light-7-transparent-2400.avif';
import light7_960_webp from '../../assets/bg/responsive/bg-light-7-transparent-960.webp';
import light7_1600_webp from '../../assets/bg/responsive/bg-light-7-transparent-1600.webp';
import light7_2400_webp from '../../assets/bg/responsive/bg-light-7-transparent-2400.webp';

export type LandingBgLayer = {
  id: string;
  depthFactor: number;
  /** Priority: base layers load first; higher = desktop-only overlays. */
  tier: 'base' | 'near' | 'far';
  fallback: string;
  avifSrcSet: string;
  webpSrcSet: string;
};

function srcSet(a960: string, a1600: string, a2400: string): string {
  return `${a960} 960w, ${a1600} 1600w, ${a2400} 2400w`;
}

export const DARK_LAYERS: LandingBgLayer[] = [
  {
    id: 'bg-dark-1',
    depthFactor: 0.15,
    tier: 'base',
    fallback: dark1_1600_webp,
    avifSrcSet: srcSet(dark1_960_avif, dark1_1600_avif, dark1_2400_avif),
    webpSrcSet: srcSet(dark1_960_webp, dark1_1600_webp, dark1_2400_webp),
  },
  {
    id: 'bg-dark-2',
    depthFactor: 0.35,
    tier: 'near',
    fallback: dark2_1600_webp,
    avifSrcSet: srcSet(dark2_960_avif, dark2_1600_avif, dark2_2400_avif),
    webpSrcSet: srcSet(dark2_960_webp, dark2_1600_webp, dark2_2400_webp),
  },
  {
    id: 'bg-dark-3',
    depthFactor: 0.65,
    tier: 'near',
    fallback: dark3_1600_webp,
    avifSrcSet: srcSet(dark3_960_avif, dark3_1600_avif, dark3_2400_avif),
    webpSrcSet: srcSet(dark3_960_webp, dark3_1600_webp, dark3_2400_webp),
  },
  {
    id: 'bg-dark-4',
    depthFactor: 0.95,
    tier: 'far',
    fallback: dark4_1600_webp,
    avifSrcSet: srcSet(dark4_960_avif, dark4_1600_avif, dark4_2400_avif),
    webpSrcSet: srcSet(dark4_960_webp, dark4_1600_webp, dark4_2400_webp),
  },
  {
    id: 'bg-dark-5',
    depthFactor: 1.3,
    tier: 'far',
    fallback: dark5_1600_webp,
    avifSrcSet: srcSet(dark5_960_avif, dark5_1600_avif, dark5_2400_avif),
    webpSrcSet: srcSet(dark5_960_webp, dark5_1600_webp, dark5_2400_webp),
  },
];

export const LIGHT_LAYERS: LandingBgLayer[] = [
  {
    id: 'bg-light-1',
    depthFactor: 0.15,
    tier: 'base',
    fallback: light1_1600_webp,
    avifSrcSet: srcSet(light1_960_avif, light1_1600_avif, light1_2400_avif),
    webpSrcSet: srcSet(light1_960_webp, light1_1600_webp, light1_2400_webp),
  },
  {
    id: 'bg-light-2',
    depthFactor: 0.3,
    tier: 'near',
    fallback: light2_1600_webp,
    avifSrcSet: srcSet(light2_960_avif, light2_1600_avif, light2_2400_avif),
    webpSrcSet: srcSet(light2_960_webp, light2_1600_webp, light2_2400_webp),
  },
  {
    id: 'bg-light-3',
    depthFactor: 0.55,
    tier: 'near',
    fallback: light3_1600_webp,
    avifSrcSet: srcSet(light3_960_avif, light3_1600_avif, light3_2400_avif),
    webpSrcSet: srcSet(light3_960_webp, light3_1600_webp, light3_2400_webp),
  },
  {
    id: 'bg-light-4',
    depthFactor: 0.8,
    tier: 'far',
    fallback: light4_1600_webp,
    avifSrcSet: srcSet(light4_960_avif, light4_1600_avif, light4_2400_avif),
    webpSrcSet: srcSet(light4_960_webp, light4_1600_webp, light4_2400_webp),
  },
  {
    id: 'bg-light-6',
    depthFactor: 1.05,
    tier: 'far',
    fallback: light6_1600_webp,
    avifSrcSet: srcSet(light6_960_avif, light6_1600_avif, light6_2400_avif),
    webpSrcSet: srcSet(light6_960_webp, light6_1600_webp, light6_2400_webp),
  },
  {
    id: 'bg-light-7',
    depthFactor: 1.3,
    tier: 'far',
    fallback: light7_1600_webp,
    avifSrcSet: srcSet(light7_960_avif, light7_1600_avif, light7_2400_avif),
    webpSrcSet: srcSet(light7_960_webp, light7_1600_webp, light7_2400_webp),
  },
];

/** Poster / hero fills its container; sizes tracks the poster canvas, not the wall. */
export const LANDING_BG_SIZES =
  '(min-width: 1600px) min(1536px, 100vw), 100vw';

/**
 * Phone: base + one near overlay.
 * Tablet: base + near.
 * Desktop: full stack.
 */
export function layersForViewport(
  all: LandingBgLayer[],
  width: number,
): LandingBgLayer[] {
  if (width < 640) {
    const base = all.filter((l) => l.tier === 'base');
    const near = all.filter((l) => l.tier === 'near').slice(0, 1);
    return [...base, ...near];
  }
  if (width < 1024) {
    return all.filter((l) => l.tier !== 'far');
  }
  return all;
}
